export { debounce as default } from 'function-tree/factories';
//# sourceMappingURL=debounce.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/operators/debounce.js
// module id = 939
// module chunks = 5